// react and mui stuff
import { useContext, useState } from "react";
import { UserContext } from "../utils/contexts";
import { ToastContext } from "../components/toast";

import Button from "@mui/joy/Button"
import FormControl from "@mui/joy/FormControl"
import FormLabel from "@mui/joy/FormLabel"
import Slider from "@mui/joy/Slider"
import Textarea from "@mui/joy/Textarea"
import Typography from "@mui/joy/Typography"

// data and stuff
import survey from "../data/survey.json"
import { surveyAPI } from "../utils/backend";
import { setData } from "../utils/setdata";


type ScaleProps = {
  label: string
  minLabel: string
  maxLabel: string
  name: string
}


function Scale({ label, minLabel, maxLabel, name }: ScaleProps) {
  const marks = new Array(10).fill(0).map((v, i) => ({ value: i + 1, label: (i + 1).toString() }))
  marks[0].label = minLabel
  marks[8].label = maxLabel
  return (
    <FormControl>
      <FormLabel>{label}</FormLabel>
      <Slider
        name={name}
        defaultValue={5}
        min={1}
        max={9}
        step={1}
        marks={marks}
        sx={{ marginBottom: "50px" }}
      />
    </FormControl>
  )
}


export default function Survey() {
  const [disabled, setDisabled] = useState(false)

  const { user, setUser } = useContext(UserContext)
  const { setToast } = useContext(ToastContext)

  return (
    <div className="contentRoot">
      <h1 className="pageTitle">Survey</h1>
      <Typography level="body-lg">Thanks for taking some time to fill out this quick survey!</Typography>
      
      <br/>
      <Typography color="warning" level="body-sm"><em>If you have bugs to report, please message BobbyTheCatfish on Discord for a faster response time.</em></Typography>

      <br/>
      <form onSubmit={(e) => {
        e.preventDefault()
        const form = new FormData(e.currentTarget)
        const survey = Object.fromEntries(form.entries()) as any
        
        survey.difficulty = parseInt(survey.difficulty)
        survey.speed = parseInt(survey.speed)

        setDisabled(true)
        surveyAPI.send(survey).then((res) => {
          if (!setData(res, setToast, user, setUser, () => setDisabled(false))) return;

          setToast({ text: "Your feedback has been recorded!", color: "success" })
        })
      }}>
          {
            survey.map(s => {
              if (s.type === "scale" && s.minLabel) {
                return (<Scale
                  key={s.id}
                  label={s.label}
                  minLabel={s.minLabel}
                  maxLabel={s.maxLabel}
                  name={s.id}
                />)
              }
              if (s.type === "paragraph") {
                return (
                  <FormControl sx={{ marginBottom: "30px" }} key={s.id}>
                    <FormLabel>{s.label}</FormLabel>
                    <Textarea minRows={2} name={s.id} key={s.id} maxRows={4}/>
                  </FormControl>
              )
              }
              return (
                <></>
              )
            })
          }
          <Button type="submit" disabled={disabled}>Submit Feedback</Button>
        </form>
    </div>
  )
}